import * as React from "react";
import { IconButton } from "components/common";
import useWidgetSummaryUnavailableReason from "ai/widget-summary/useWidgetSummaryUnavailableReason";
const WidgetSummaryButton = ({ widgetType, widgetEmpty, noData, onClick }) => {
  const unavailableReason = useWidgetSummaryUnavailableReason(widgetType);
  let disabledReason = unavailableReason;
  if (!disabledReason && widgetEmpty) {
    disabledReason = "Widget is empty.";
  } else if (!disabledReason && noData) {
    disabledReason = "No data to analyze.";
  }
  return /* @__PURE__ */ React.createElement(
    IconButton,
    {
      disabled: !!disabledReason,
      name: "note_add",
      iconType: "regular",
      title: `Generate Widget Summary${disabledReason ? ` - Disabled: ${disabledReason}` : ""}`,
      onClick
    }
  );
};
export default WidgetSummaryButton;
